export const metadataOptions = [
  { key: "color", label: "Color", type: "string" },
  { key: "gender", label: "Gender", type: "string" },
  { key: "metal", label: "Metal", type: "string" },
  { key: "plating", label: "Plating", type: "string" },
  { key: "stone_color", label: "Stone Color", type: "string" },
  { key: "stone_setting", label: "Stone Setting", type: "string" },
  { key: "stone_shape", label: "Stone Shape", type: "string" },
  { key: "thickness", label: "Thickness", type: "numeric" },
  { key: "weight", label: "Weight", type: "numeric" },
  { key: "lock_type", label: "Lock Type", type: "string" },
  { key: "adjustable", label: "Adjustable", type: "boolean" },
  { key: "with_chain", label: "With Chain", type: "boolean" },
  { key: "price", label: "Price", type: "numeric" },
  { key: "status", label: "Status", type: "status" },
];
